import './quick-book-modal.scss'
import { Modal, type QuickNavigatorSelections } from '@vista-digital/occ-ui'
import { QuickNavigatorComponent } from '@vista-digital/occ-ui/src/lib/components/quick-navigator/quick-navigator'
import type { FC } from 'react'
import { useCallback } from 'react'
import { useInitialDataHeader } from '@/common/hooks/useInitialData'
import { navigationService } from '@/common/services/navigation.service'
import { toFriendlyUrlString } from '@/common/utils/toFriendlyUrlString'
import { QuickBookPropsApi } from '@/features/layout/header/models'
import { quickBookConfig } from '@/features/layout/header/subcomponents/quickBookModal/quickBook.config'

export interface QuickBookProps {
    isOpen: boolean
    onClose: () => void
}

export const QuickBookModal: FC<QuickBookProps> = props => {
    const { isOpen, onClose } = props
    const { quickBook = new QuickBookPropsApi() } = useInitialDataHeader()
    const { headingLabel, ...displayText } = quickBook

    const handleQuickBookClick = useCallback(
        (selections: QuickNavigatorSelections) => {
            const { site, film, screeningDate, showtime } = selections

            const isSiteOnlySelected = site && !film
            const isFilmOnlySelected = !site && film
            const areSiteAndFilmOnlySelected = site && film && !screeningDate
            const hasScreeningDate = site && film && screeningDate && !showtime
            const allSelected = site && film && screeningDate && showtime

            onClose()

            if (isSiteOnlySelected) {
                const siteName = toFriendlyUrlString(site?.name.text)
                navigationService.goToNamedSubpage('Cinema', siteName)
            }

            if (isFilmOnlySelected) {
                const filmName = toFriendlyUrlString(film?.title.text)
                navigationService.goToPage('FilmDetails', { filmName, filmId: film?.id })
            }

            if (areSiteAndFilmOnlySelected) {
                const siteName = toFriendlyUrlString(site?.name.text)
                navigationService.goToNamedSubpage('Cinema', siteName, { filmId: film?.id })
            }

            if (hasScreeningDate) {
                const siteName = toFriendlyUrlString(site?.name.text)
                const params = { filmId: film?.id, screeningDate: screeningDate }
                navigationService.goToNamedSubpage('Cinema', siteName, params)
            }

            if (allSelected) {
                navigationService.goToPageOrSubPage('Ticketing', 'SeatPicker', { showtimeId: showtime.id })
            }
        },
        [navigationService]
    )

    return (
        <Modal
            show={isOpen}
            onClose={onClose}
            heading={headingLabel}
            anchoredToTop={true}
            className={'quick-book-modal'}
        >
            <QuickNavigatorComponent
                {...quickBookConfig}
                displayText={displayText}
                events={{ onActionButtonClicked: handleQuickBookClick }}
            />
        </Modal>
    )
}
